export default __webpack_public_path__ + "static/media/feat-icon1.159c849f.svg";